// Libs
import React from 'react'
import styled, { css } from 'styled-components'

// Comps
import { mobileScreen, colors } from '../utils'
import { backgroundImage } from '../utils/styles'

interface Props {
  background?: string
  className?: string
}

export const bowedBackgroundTopStyles = css`
  position: relative;

  .bowed-background {
    width: 100%;
    max-width: 1300px;
    position: relative;
    margin: auto;
    padding-top: 60px;
    overflow: hidden;

    ${mobileScreen(css`
      padding-top: 40px;
    `)}

    &:before {
      content: ' ';
      position: absolute;
      left: -20px;
      right: -20px;
      top: 0px;
      bottom: 0px;

      border-top-left-radius: 95% 20%;
      border-top-right-radius: 95% 20%;
      background: ${(props) => {
        return props['background'] || ''
      }};
      z-index: -1;

      ${mobileScreen(css`
        border-top-left-radius: 95% 10%;
        border-top-right-radius: 95% 10%;
      `)}
    }
  }
`

const Container = styled.div<Props>`
  ${bowedBackgroundTopStyles}
`

export const BowedTopBackground: React.FC<Props> = (props) => {
  // Props
  const { children, className, background } = props

  //..
  return (
    <Container
      className={`BowedTopBackground ${className}`}
      background={background}>
      <div className="bowed-background">{children}</div>
    </Container>
  )
}
